import { Component, OnInit } from '@angular/core'
import { GlobalConstants } from 'src/app/constants/global-constants'
import { ActivityAPIModel, StatusCountAPIModel } from 'src/app/models/api.model'
import { ViewForSelectorComponent } from '../../common/view-for-selector/view-for-selector.component'
import { ActivityService } from 'src/app/services/activity/activity.service'
import {
  ACTIVITY_ID,
  ACTIVITY_NAME_WITH_TYPE_INDICATOR,
  REQUEST_INITIATED_ON,
  TASK_CURRENT_STATUS,
  OWNER_DISPLAY_ID,
  DAYS_ELAPSED,
  RESPONSE_DUE_BY,
  COMPANY_ENTITY_DISPLAY_ID
} from 'src/app/constants/ui.columns'
import {
  ACTIVITY_RECEIVED,
  IN_PROGRESS,
  PENDING_WITH_ER,
  PENDING_WITH_DEPARTMENT,
  PENDING_WITH_EE,
  COMPLETED
} from 'src/app/constants/stats-cards'

@Component({
  selector: 'app-activity-dashboard',
  templateUrl: './activity-dashboard.component.html',
  styleUrls: ['./activity-dashboard.component.scss']
})
export class ActivityDashboardComponent implements OnInit {
  pendingItemsList: ActivityAPIModel[] = []
  statusCountMap: StatusCountAPIModel[] = []
  pendingItemsTableColumns = [
    COMPANY_ENTITY_DISPLAY_ID,
    ACTIVITY_ID,
    ACTIVITY_NAME_WITH_TYPE_INDICATOR,
    OWNER_DISPLAY_ID,
    REQUEST_INITIATED_ON,
    DAYS_ELAPSED,
    RESPONSE_DUE_BY,
    TASK_CURRENT_STATUS
  ]
  statsCards = [ACTIVITY_RECEIVED, IN_PROGRESS, PENDING_WITH_ER, PENDING_WITH_DEPARTMENT, PENDING_WITH_EE, COMPLETED]
  readonly routingLink = `/${GlobalConstants.ROUTING.ACTIVITY}/{0}/${GlobalConstants.ROUTING.DETAILS}`

  constructor(private activityService: ActivityService) {}

  ngOnInit(): void {
    this.activityService.dispatchFetchActivityDashboardDataAction(
      ViewForSelectorComponent.defaultValue,
      GlobalConstants.SORT_COLUMN.CREATED_DATETIME,
      null
    )

    this.activityService.getActivityDashboardInfo().subscribe(activityDashboardInfo => {
      if (activityDashboardInfo) {
        this.pendingItemsList = activityDashboardInfo?.activityPendingItemsList?.content
        this.statusCountMap = activityDashboardInfo?.statusCountMap
      }
    })
  }

  handleViewForData($event: any) {
    this.pendingItemsList = []
    this.activityService.dispatchFetchActivityDashboardDataAction($event, 'createdDatetime', null)
  }
}
